import * as React from "react";
import type { SVGProps } from "react";
const SvgAirplaneToLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.35 22A2.65 2.65 0 0 0 15 19.35V15h1.68l.07.37a2.65 2.65 0 0 0 5.25-.52v-5.7a2.65 2.65 0 0 0-5.25-.52l-.07.37H15V4.65a2.53 2.53 0 0 0-.75-1.86 2.63 2.63 0 0 0-4.46 1.34L8.81 9H5a3 3 0 1 0 0 6h3.81l.95 4.86A2.64 2.64 0 0 0 12.35 22m5.15-9H14a1 1 0 0 0-1 1v5.35a.65.65 0 0 1-1.28.13l-1.11-5.67a1 1 0 0 0-1-.81H5a1 1 0 0 1 0-2h4.63a1 1 0 0 0 1-.81l1.09-5.68a.65.65 0 0 1 1.07-.32.59.59 0 0 1 .18.45L13 10a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-.8l.22-1.2a.65.65 0 0 1 1.28.15v5.7a.65.65 0 0 1-1.28.15l-.24-1.18a1 1 0 0 0-.98-.82"
    />
  </svg>
);
export default SvgAirplaneToLeft;
